import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AssetModuleNavbar from "./AssetModuleNavbar";
import API_BASE_URL from "../config";

const Section = ({ title, children }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-3 border">
      <div className="fw-bold p-2 border-bottom d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", backgroundColor: "#DFE4EB" }}
        onClick={() => setOpen(!open)}>
        <span>{title}</span><span>{open ? "▾" : "▸"}</span>
      </div>
      {open && <div className="row g-3 p-3">{children}</div>}
    </div>
  );
};

const initialForm = { auditName: "", auditPeriod: "MONTHLY", department: "", location: "" };

export default function NewAuditRecord() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const bl = document.createElement("link"); bl.rel = "stylesheet"; bl.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"; document.head.appendChild(bl);
    const ic = document.createElement("link"); ic.rel = "stylesheet"; ic.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"; document.head.appendChild(ic);
    return () => { bl.remove(); ic.remove(); };
  }, []);

  useEffect(() => {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    if (!token) { toast.error("You must be logged in."); navigate("/"); return; }
    // if (!roles.includes("ROLE_ADMIN")) { toast.error("Unauthorized."); navigate("/"); }
  }, [navigate, token]);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.auditName.trim()) { toast.error("Audit name is required."); return; }
    try {
      setSubmitting(true);
      const res = await fetch(`${API_BASE_URL}/api/asset-audits`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      toast.success(`Audit created with ${data.totalItems} asset${data.totalItems !== 1 ? "s" : ""} to verify.`);
      navigate("/allauditrecords");
    } catch (err) { toast.error(err.message || "Failed to create audit."); }
    finally { setSubmitting(false); }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} />
      <div className="fixed-top"><AssetModuleNavbar /></div>
      <div className="container-fluid my-4" style={{ paddingTop: "90px" }}>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="fw-bold mb-0"><i className="bi bi-clipboard2-plus me-2"></i> New Audit Session</h4>
            <div className="d-flex gap-2 mt-1 mb-1">
            <button className="btn btn-primary" type="submit" form="audit-form" disabled={submitting}>
              {submitting ? <><span className="spinner-border spinner-border-sm me-1"></span>Creating...</> : "Save"}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => navigate(-1)}>Cancel</button>
          </div>
            <div className="text-muted mt-1" style={{ fontSize: 13 }}>Create a verification cycle to scan assets and track presence, condition, and discrepancies.</div>
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/allauditrecords")}>
              <i className="bi bi-list-ul me-1"></i> All Audits
            </button>
          </div>
        </div>

        <form id="audit-form" onSubmit={handleSubmit}>
          <Section title="Audit Setup">
            <div className="col-md-4">
              <label className="form-label">Audit Name <span className="text-danger">*</span></label>
              <input className="form-control" value={formData.auditName}
                onChange={e => setFormData(p => ({ ...p, auditName: e.target.value }))}
                placeholder="e.g. Q2 IT Asset Verification" />
            </div>
            <div className="col-md-3">
              <label className="form-label">Audit Period</label>
              <select className="form-select" value={formData.auditPeriod}
                onChange={e => setFormData(p => ({ ...p, auditPeriod: e.target.value }))}>
                <option>MONTHLY</option><option>QUARTERLY</option><option>ANNUAL</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">Department <span className="text-muted">(optional)</span></label>
              <input className="form-control" value={formData.department}
                onChange={e => setFormData(p => ({ ...p, department: e.target.value }))}
                placeholder="Leave blank for all departments" />
            </div>
            <div className="col-md-2">
              <label className="form-label">Location <span className="text-muted">(optional)</span></label>
              <input className="form-control" value={formData.location}
                onChange={e => setFormData(p => ({ ...p, location: e.target.value }))}
                placeholder="Leave blank for all" />
            </div>
            <div className="col-12">
              <div className="alert alert-info mb-0 py-2">
                <i className="bi bi-info-circle me-2"></i>
                All non-disposed assets matching your dept/location filter will be added as checklist items.
                Leave both blank to audit <strong>all assets</strong>.
              </div>
            </div>
          </Section>

          <div className="d-flex gap-2 mt-3 mb-4">
            <button className="btn btn-primary" type="submit" disabled={submitting}>
              {submitting ? <><span className="spinner-border spinner-border-sm me-1"></span>Creating...</> : "Save"}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => navigate(-1)}>Cancel</button>
          </div>
        </form>
      </div>
    </>
  );
}
